import VideoPageContainer from "../components/ExperienceVideos/VideoPageContainer";

export default function VideoPage() {
  return <VideoPageContainer pageTitle="Your experience videos" />;
}
